import { Component, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MapDataService } from 'src/app/services/map-data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-map-image-change',
    templateUrl: './map-image-change.component.html',
    styleUrls: ['./map-image-change.component.scss'],
    standalone: false
})
export class MapImageChangeComponent {
  @Input() mapId: string | number;
  @Input() userId: number;
  
  @ViewChild('fileInput') fileInput: ElementRef;

  selectedFile: File | null = null;
  selectedFileName: string = '';
  selectedImagePreview: string | ArrayBuffer | null = null;
  isUploading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private mapDataService: MapDataService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.selectedFileName = this.selectedFile.name;

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        this.selectedImagePreview = e.target?.result || null;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  uploadImage(): void {
    if (!this.selectedFile || !this.mapId) {
      this.toastService.showSuccess('Choose an image file.', 'error');
      return;
    }

    this.isUploading = true;

    // Convert file to base64
    const reader = new FileReader();
    reader.onload = () => {
      const base64Image = reader.result as string;

      // Prepare payload with base64 image
      const payload = {
        map_id: this.mapId,
        user_id: this.userId,
        thumbnail: base64Image
      };

      // Call API with JSON payload
      this.mapDataService.updateMapThumbnail(this.mapId, payload).subscribe({
        next: (response) => {
          this.isUploading = false;
          this.activeModal.close('updated');
        
          this.cdr.detectChanges();},
        error: (error) => {
          this.isUploading = false;
          this.toastService.showSuccess("We couldn't change the map picture. Please try again.", 'danger');
          console.error('Upload error:', error);
        
          this.cdr.detectChanges();}
      });
    
          this.cdr.detectChanges();};

    reader.onerror = () => {
      this.isUploading = false;
      this.toastService.showSuccess("That picture couldn't be read. Try a different image.", 'danger');
    };

    reader.readAsDataURL(this.selectedFile);
  }

  close(): void {
    this.activeModal.close();
  }
}
